function CartReload(data) {
  var container = document.getElementById('cart-table')
  var tT = document.getElementById('total-top');
  var c = document.querySelector('.cart-table');
  var tB = document.getElementById('total-bottom');
  const parser = new DOMParser();
  const htmlDocument = parser.parseFromString(data, 'text/html');
  var nTT = htmlDocument.documentElement.querySelector('#total-top');
  var nC = htmlDocument.documentElement.querySelector('.cart-table');
  var nTB = htmlDocument.documentElement.querySelector('#total-bottom');
  tT.replaceWith(nTT);
  c.replaceWith(nC);
  tB.replaceWith(nTB);
  Quantity(container);
  CartButtons();
}

function CartChange(q,container) {
  var it = q.closest('.item');
  var id = it.getAttribute('data-product-id');
  var q =  it.querySelector('.item-qty').value;
  var iQ = it.querySelector('.item-qty');
  var s = it.querySelector('.error');
  var rct = container.getAttribute('data-recent');
  var aB = document.getElementById('ajaxBusy');
  var cTa = document.getElementById('cart-table');
  var cC = document.querySelectorAll('.cartCountSelector');
  var cT = document.querySelector('.cartTotalSelector');
  var tT = document.getElementById('total-cart-top');
  var c = document.querySelector('.cart-table');
  var tC = document.getElementById('cart-total');
  var tB = document.getElementById('total-cart-bottom');
  var dC = document.querySelector('.discount-cart');
  var aS = document.querySelector('.animate-section'); 
  if (q != '') {
    aB.style.display = 'block';
  }
  fetch(theme.routes_cart_change_url + '.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({'quantity': q,'id':id})
  }).then(function(r) {
    return r.json();
  }).then(function(j) {
    if (q != '') {
      cC.forEach(function(c) {
        c.textContent = j.item_count;
      });
      cT.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      tT.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      if(j.cart_level_discount_applications.length > 0) {
        tC.innerHTML = Shopify.formatMoney(j.items_subtotal_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
        dC.innerHTML = Shopify.formatMoney('-' + j.total_discount, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
      }
      tB.innerHTML = Shopify.formatMoney(j.total_price, theme.moneyFormat).replace(/((\,00)|(\.00))$/g, '');
    }
    if (j.item_count == 0) {
      cTa.querySelector('.full-form').remove();
      cTa.querySelector('.empty-form').classList.remove('hidden');
      aB.style.display = 'none';
      if (theme.dropdown == true) {
        document.querySelector('.cart-count-mobile').setAttribute('href', theme.routes_cart_url);
        document.querySelector('.cart-count-mobile').classList.remove('void');
      }
      document.getElementById('cart-dropdown').remove();
      if(rct == 'true' && aS){
        document.querySelector('.animate-section').classList.add('go','up');
      };
    } else {
      fetch(theme.routes_cart_url)
      .then(response => response.text())
      .then(data => {
        if (q != '') {              
          var x = theme.cart;
          CartDrop(x);              
          if (q == 0) {
            it.remove();
          }
          CartReload(data)
          aB.style.display = 'none';
        }
        imageObserver();
      }).catch(function(err) {
        console.error('!: ' + err)
      });
    };
  }).catch(function(err) {
    console.error('!: ' + err)
  });
}

function CartButtons() {
  var container = document.getElementById('cart-table')
  var qB = container.querySelectorAll('.qtybtn');
  qB.forEach(function(q) {
    setTimeout(function () {
      q.onclick = function(ev){
        CartChange(q,container);
      }
    }, 1);
  })
  var qI = container.querySelectorAll('.item-qty');
  qI.forEach(function(q) {
    setTimeout(function () {
      q.addEventListener('input', event => {
        CartChange(q,container);
      });
    }, 1);
  })
}

theme.Cart = (function() {
  function Cart(container) {
    var sectionId = container.getAttribute('data-section-id');
    var chk = container.getAttribute('data-check');
    var rct = container.getAttribute('data-recent');
    var rV = document.getElementById('recently-viewed');
    theme.cart = true;
    Quantity(container);
    if(chk == 'true'){      
      var nC = container.querySelector('[name="checkout"]');
      document.getElementById('cart-terms').onclick = function(ev){
        if (this.checked == true) {
          nC.classList.remove('outline');
          nC.removeAttribute('disabled');
          nC.setAttribute('aria-label', theme.language.cart_general_checkout);
          nC.value = theme.language.cart_general_checkout;
          nC.textContent = theme.language.cart_general_checkout;
        } else {
          nC.classList.add('outline');
          nC.setAttribute('disabled', true);
          nC.setAttribute('aria-label', theme.language.cart_general_agree);
          nC.value = theme.language.cart_general_agree;
          nC.textContent = theme.language.cart_general_agree;
        }
      };
    };
    CartButtons(container);
    // Based on https://community.shopify.com/c/Shopify-Discussion/How-to-get-recent-viewed-products-in-Shopify-Store-in-any-theme/td-p/887103
    if(rct == 'true'){
      function gPD (){
        const pD = JSON.parse(localStorage.getItem('rVP'));
        const rVH = []
        if (pD) {
          rV.classList.remove('hidden');
          if (theme.settings.borders) {var b = 'borders '} else {var b = '';}
          if (theme.settings.title_align) {var t = ' title-align'} else {var t = '';}
          pD.forEach(function(item,i){
            if (item.pFI) {
              var h = '';
              var l =  theme.settings.align;
            } else {
              var h = ' hidden';
              var l = 'left ' + theme.settings.align;
            }
            if (item.pPMn > 0) {
              if (item.pPV) {
                var p = theme.language.products_product_from + '<h6>' + Shopify.formatMoney(item.pP,theme.moneyFormat) + '</h6>';
              } else {
                if (item.pPC > item.pP) {
                  var p = '<h6>' + Shopify.formatMoney(item.pP,theme.moneyFormat) + ' | <del>' + Shopify.formatMoney(item.pPC,theme.moneyFormat) + '</del></h6>';
                } else {                  
                  var p = '<h6>' + Shopify.formatMoney(item.pP,theme.moneyFormat) + '</h6>';
                }
              }
            } else {
              if (item.pPV) {                
                var p = '<h6>' + theme.language.products_product_free + ' - ' + Shopify.formatMoney(item.pPMx,theme.moneyFormat) + '</h6>';
              } else {
                var p = '<h6>' + theme.language.products_product_free + '</h6>';
              }
            }
            if (theme.settings.vendor) {
              var v = '<p class="product-logistics"><span class="vendors"><a href="' + item.pVU + '" title="' + item.pV + '">' + item.pV + '</a></span></p>';
            } else {
              var v = '';
            }
            rVH.push('<div class="product ' + b + ' two-half animate animate-loop-' + i + '"><div class="product-border"><div class="product-thumb-container"><div class="product-thumb title-align cart' + t + h +'"><div class="relative lazycontainer lazyignore"><a href="' + item.pU + '" title="' + item.pT + '" class="img-align"><img src="' + item.pI + '" alt="' + item.pT + '" class="lazyload lazyloaded img-align ' + item.pIa +' cart"/></a></div></div></div><div class="product-details ' + l + '"><div class="product-title"><h5><a href="' + item.pU + '" title="' + item.pT + '">' + item.pT + '</a></h5></div><div class="product-price">' + p + '</div>' + v + '</div></div></div></div>')
          })
          const rB = rVH.join('');
          const cB = document.getElementsByClassName('recently-viewed');
          for (let i = 0; i < cB.length; i++) {
            cB[i].innerHTML = rB; 
          }
        }
      }    
      gPD();
    };
    if (Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }
  return Cart;
})();